import classNames from 'classnames'
import React from 'react'

import { Title } from './substep-heading.styles'

type Props = {
  title: string
  className?: string
  titleVariant?: 'small' | 'normal' | 'large'
}
export default function SubstepHeading({
  title,
  className,
  titleVariant,
}: Props) {
  return (
    <Title
      data-testid="substep-heading"
      className={classNames(className, 'substep-title')}
      title={title}
      $variant={titleVariant || 'normal'}
    >
      {title}
    </Title>
  )
}
